import http, { url } from '../../http'

const API_URL = "subepp"

class subeppAPI {

  async save(subepp) { 
    const response = await http(`${API_URL}/save`, 'POST', subepp)
    return response
  }

  async getAllsubeppPage(ID, page, search) {
    const response = await http(`subepp_ind/${ID}?page=${page}&search=${search}`, 'POST', {
      page: page
    })
    return response || null
  }
 

  async getsubepp(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updatesubepp(id, subepp) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', subepp)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

}

export default new subeppAPI()